import { render, staticRenderFns } from "./SpecialistTravelDetail.vue?vue&type=template&id=27f5ab76"
import script from "./SpecialistTravelDetail.vue?vue&type=script&lang=js"
export * from "./SpecialistTravelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports